import { BillingSettingComp } from "../components/billingSettingComp"
import { CustomerSettings } from "../components/CustomerSettings"
import { NotificationSetting } from "../components/notificationSettingComp"
import { ProfileSetting } from "../components/profileSettingComp"
import { SecuritySetting } from "../components/securitySettingComp"
import { UserRightsComp } from "../components/userRightsComp"
import { DepartmentSettings } from "../components/DepartmentSettings"
import { ThemeSettings } from "../components/themeSettings"
import AppModusSettings from "../components/AppModusSettings"
import AIImageSettings from "../components/aiImageSettings"
import { LinkedinSettings } from "../components/LinkedinSettings"


export const SettingFactory = ({setting}) => {
    switch(setting){
        case 1 :return  <ProfileSetting/>
        case 2: return <SecuritySetting/>
        case 3: return  <BillingSettingComp/>
        case 4: return  <NotificationSetting/>
        case 5: return  <UserRightsComp/>
        case 6: return  <CustomerSettings/>
        case 7: return  <DepartmentSettings/>
        case 8: return  <ThemeSettings/>
        case 9: return  <AppModusSettings/>
        case 10: return  <AIImageSettings/>
        case 11: return  <LinkedinSettings/>
    }
}